import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Pageable } from 'app/interfaces/Pageable/pageable';
import { Parametro } from 'app/interfaces/parametro';
import { ParametroFiltro } from 'app/interfaces/parametro-filtro';
import { environment } from 'environments/environment';
import { TimezoneService } from 'app/utils/timezone.service';

@Injectable({
  providedIn: 'root',
})
export class ParametroHttpService {
  constructor(
    private _http: HttpClient,
    private _timezoneService: TimezoneService
  ) {}

  /**
   * Função para buscar todos parametros;
   * @param filtro
   * @returns
   */
  getAll() {
    return this._http.get<Parametro[]>(`${environment.apiUrl}/api/parameter/v1/parametros`);
  }

  /**
   * Função para buscar todos parametros;
   * @param filtro
   * @returns
   */
  getAllPageable({ filtro, size = 10, page = 0, sort = '' }: { filtro: ParametroFiltro; size?: number; page?: number; sort?: string }) {
    return this._http.post<Pageable>(`${environment.apiUrl}/api/parameter/v1/parametros/pageable?sort=${sort}&size=${size}&page=${page}`, filtro);
  }

  /**
   * Função para atualizar um parametro pelo id;
   * @param parametro
   * @returns
   */
  update(parametro: Parametro) {
    return this._http.put<Parametro>(`${environment.apiUrl}/api/parameter/v1/parametros/${parametro.parametroId}`, parametro);
  }

  updateAll(parametros: Parametro[]) {
    return this._http.put<boolean>(`${environment.apiUrl}/api/parameter/v1/parametros/all`, parametros);
  }

  /**
   * Função para deletar um parametro pelo id;
   * @param parametro
   * @returns
   */
  create(parametro: Parametro) {
    return this._http.post<Parametro>(`${environment.apiUrl}/api/parameter/v1/parametros`, parametro);
  }

  /**
   * Função para deletar um parametro pelo id;
   * @param parametro
   * @returns
   */
  delete(parametro: Parametro) {
    return this._http.delete<boolean>(`${environment.apiUrl}/api/parameter/v1/parametros/${parametro.parametroId}`);
  }

  /**
   * Função para buscar todos parametros;
   * @param filtro
   * @returns
   */
  getParametros() {
    return this._http.get<Parametro[]>(`${environment.apiUrl}/api/parameter/v1/parametros`);
  }

  /**
   * Função para buscar parametro Por Nome;
   * @param filtro
   * @returns
   */
  getParametroByName(parametroNome: string) {
    return this._http.get<Parametro>(`${environment.apiUrl}/api/parameter/v1/parametros/nome`, {
      params: { nome: parametroNome },
    });
  }

  getAllAudit(parametroId: any, page: number, email: string, dataInicial: Date, dataFinal: Date, tipoAuditoria: string) {
    let params = {
      size: 10,
      page: page,
      dataInicial: dataInicial && Array.isArray(dataInicial) && dataInicial.length > 0 ? this._timezoneService.utcToUserString(dataInicial) : '',
      dataFinal: dataFinal && Array.isArray(dataFinal) && dataFinal.length > 0 ? this._timezoneService.utcToUserString(dataFinal) : '',
      email: email ? email : '',
      tipoAuditoria: tipoAuditoria ? tipoAuditoria : '',
      id: parametroId,
      entidade: 'parametro',
    };

    return this._http.get<Pageable>(`${environment.apiUrl}/api/parameter/v1/parametros/auditorias`, { params: params });
  }

  getAuditComparacao(nomeParametro: string, rev: number) {
    let params = {
      entidade: 'parametro',
      rev: rev,
      nomeParametro: nomeParametro
    };

    return this._http.get<any[]>(`${environment.apiUrl}/api/parameter/v1/parametros/comparacao-audit`, { params });
  }

  sincronizarParametros() {
    return this._http.get<boolean>(`${environment.apiUrl}/api/parameter/v1/parametros/sincronizar-parametros`);
  }
}
